<template>
  <div class="pkg-content">
    <div class="msg">
      <el-card class="box-card card1">
        <div class="search">
          <el-button @click="goBack()">返回</el-button>
          <el-button type="primary" v-if="dataDetail.workStatus === 20"
                @click="save()" :disabled="saveButton">保存</el-button>

        </div>
      </el-card>
    </div>

    <!-- 作品审核 -->
    <div class="msg">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="margin-right: 10px" >审核</span>
          <el-tooltip placement="bottom-start" effect="light" >
            <div slot="content" v-if=" dataDetail.manageType == '1'">该区域可以审核用户上传的作品，选择“通过”，作品会发布到app端显示；选择“未通过”，作品将不会发布到app端显示。如“未通过”，建议填写“理由”，告知用户为何没有通过的原因。</div>
            <div slot="content" v-if=" dataDetail.manageType == '2'">该区域可以审核用户上传的提问，选择“通过”，提问会发布到app端显示；选择“未通过”，提问将不会发布到app端显示。如“未通过”，建议填写“理由”，告知用户为何没有通过的原因。</div>
            <div slot="content" v-if=" dataDetail.manageType == '3'">该区域可以审核用户上传的回答，选择“通过”，回答会发布到app端显示；选择“未通过”，回答将不会发布到app端显示。如“未通过”，建议填写“理由”，告知用户为何没有通过的原因。</div>
            <em class="el-icon-question" style="color: #1C69D3"></em>
          </el-tooltip>
        </div>
        <div>
          <el-row>
            <el-col :span="2" style="width: 120.91px">
              <span>审核结果</span>
            </el-col>
            <el-col :span="10" style="margin-bottom: 20px">
              <el-radio-group v-model="approveResult" :disabled="true" >
                <el-radio :label=20>通过</el-radio>
                <el-radio :label=30>未通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <span>理由</span>
            </el-col>
            <el-col :span="12">
              <el-input
                      :disabled="true"
                      type="textarea"
                      show-word-limit
                      maxlength="500"
                      :autosize="{ minRows: 5 }"
                      v-model="reason">
              </el-input>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 基本信息 -->
    <div class="msg">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <div>
          <el-row style="margin-bottom: 10px">
            <el-col :span="7">
              <span style="margin-right: 48px">编号</span><label>{{dataDetail.workNumber}}</label>
            </el-col>
            <el-col :span="9">
              <span>提交人</span><label>{{worksSubmitterName}}</label>
            </el-col>
            <el-col :span="7">
              <span>提交时间</span><label>{{dataDetail.createTime}}</label>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7"  style="margin-bottom: 10px">
              <span>公司简称</span><label>{{dataDetail.dealerAbbreviation}}</label>
            </el-col>
            <el-col :span="9">
              <span>审批人</span><label>{{approveUserName}}</label>
            </el-col>
            <el-col :span="7">
              <span style="margin-right: 48px">状态</span><label>{{ workStatus }}</label>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7" v-if="dataDetail.manageType == '1'">
              <span style="margin-right: 48px">类型</span><label>作品</label>
            </el-col>
            <el-col :span="7" v-if="dataDetail.manageType == '2'">
              <span style="margin-right: 48px">类型</span><label>提问</label>
            </el-col>
            <el-col :span="7" v-if="dataDetail.manageType == '3'">
              <span style="margin-right: 48px">类型</span><label>回答</label>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <!-- 提问内容：类型为回答时，显示提问模块；否则不显示该模块。 -->
    <div class="msg" v-if="dataDetail.manageType == '3'" >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>提问</span>
        </div>
        <el-row>
          <el-col :span="7">
            <div >
              <span>分组:</span><label>{{questionGroupText}}</label>
              <group-type ref="child" @abdd="getGroup"></group-type>
            </div>
          </el-col>

          <el-col :span="7">
            <div >
              <span>提交人:</span><label>{{dataDetail.questionUser}}</label>
            </div>
          </el-col>
        </el-row>
        <div style="height: 10px"></div>
        <div >
          <span>标题:</span><label>{{dataDetail.questionTitle}}</label>
        </div>
        <div style="height: 10px"></div>
        <div >
          <span>正文:</span><label>{{dataDetail.questionContent}}</label>
        </div>
      </el-card>
    </div>

    <!-- 品牌 -->
    <div class="msg">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>所属品牌</span>
          <el-tooltip placement="bottom-start" effect="light" >
            <div slot="content">{{ brandDoc[dataDetail.manageType] }}</div>
            <em class="el-icon-question" style="color: #1C69D3; margin-right: 10px"></em>
          </el-tooltip>
        </div>
        <div style="width: 600px">
          <el-checkbox-group v-model="brandsList">
            <el-checkbox v-for="(brand, index) in brands" :label="brand.code" :disabled="!isSelectBrand"
                :key="index" >{{brand.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-card>
    </div>

    <!-- 标题 -->
    <div class="msg">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>标题</span>
        </div>
        <div style="width: 600px">
          <el-input :disabled="true"  v-model="dataDetail.title" :autosize="true" type="textarea" maxlength="255"></el-input>
        </div>
      </el-card>
    </div>
    <!-- 正文 -->
    <div class="msg">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>正文</span>
        </div>
        <div>
          <div style="width: 600px">
            <el-input :disabled="true"  v-model="dataDetail.textContent" :rows="10" type="textarea" maxlength="1000"></el-input>
          </div>
          <div style="height: 10px"></div>
          <el-row>
            <el-col :span="24">
<!--              <div style="word-wrap: break-word;white-space: normal"><pre>{{dataDetail.textContent}}</pre></div>-->
<!--              <el-input v-model="dataDetail.textContent" :autosize="true" type="textarea" maxlength="255"></el-input>-->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="fileType == '10'">
              <viewer :images="imageList">
                <img
                  v-for="(url,index) in imageList"
                  style="width:100px; height:100px; margin-right: 5px" alt=""
                  :src="url"
                  :key="index">
              </viewer>
            </el-col>
            <el-col :span="24" v-if="fileType == '20'">
              <div>
                <video
                 width="300"
                 height="200"
                 :poster="dataDetail.fileList[0].fileCoverUrl"
                 :src="dataDetail.fileList[0].fileUrl"
                 controls="controls">
                  您的浏览器不支持 video 标签。
                </video>
              </div>
            </el-col>
            <el-col :span="24" v-if="fileType == '30' || fileType == '40'">
              <div>
                <a :href="dataDetail.fileList[0].fileUrl" download>{{ dataDetail.fileList[0].fileName }}</a>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 标签 -->
    <div class="msg" v-if=" dataDetail.manageType !== '3'">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>标签</span>
          <el-tooltip placement="bottom-start" effect="light" >
            <div slot="content" v-if=" dataDetail.manageType == '1'">该区域可以设置或修改用户作品的标签。</div>
            <div slot="content" v-if=" dataDetail.manageType == '2'">该区域可以设置或修改用户提问的标签。</div>
            <div slot="content" v-if=" dataDetail.manageType == '3'">该区域展示回答所属提问的标签。</div>
            <em class="el-icon-question" style="color: #1C69D3; margin-right: 10px"></em>
          </el-tooltip>
        </div>
        <div v-if="!isThemeOut ">
          <el-tag style="margin-bottom: 5px" v-if = "dataDetail.themeId == null || dataDetail.themeId == '' "
            :key="tag.tagContent"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag.tagContent}}
          </el-tag>


          <el-input
            style="width: 200px;margin-bottom: 5px "
            v-if=" (dataDetail.themeId == null || dataDetail.themeId == '') && dataDetail.manageType != '3' "
            class="input-new-tag"
            v-model="inputValue"
            placeholder="请输入标签"
            maxlength="50"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm">
          </el-input>
        </div>

        <div v-if="isThemeOut">
          <el-tag style="margin-bottom: 5px" v-if=" dataDetail.manageType == '1'"
                  :key="tag.tagContent"
                  v-for="tag in dynamicTags">
<!--                  closable-->
<!--                  :disable-transitions="false"-->
<!--                  @close="handleClose(tag)" >-->
            {{tag.tagContent}}
          </el-tag>
        </div>
        <div>
          <el-tag style="margin-bottom: 5px" v-if=" dataDetail.manageType == '3'"
                  :key="tag.tagContent"
                  v-for="tag in dynamicAnswerTags">
            {{tag.tagContent}}
          </el-tag>
        </div>
      </el-card>
    </div>

    <!-- 回答标签 -->
    <div class="msg" v-if=" dataDetail.manageType == '3'">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>标签</span>
          <el-tooltip placement="bottom-start" effect="light" >
            <div slot="content" v-if=" dataDetail.manageType == '3'">该区域展示回答所属提问的标签。</div>
            <em class="el-icon-question" style="color: #1C69D3; margin-right: 10px"></em>
          </el-tooltip>
        </div>

        <div>
          <el-tag style="margin-bottom: 5px; background-color: #F5F7FA; border-color: #E4E7ED; color: #C0C4CC;"
                  :key="tag.tagContent"
                  v-for="tag in dynamicAnswerTags">
            {{tag.tagContent}}
          </el-tag>

          <el-tag style="margin-bottom: 5px"
                  :key="tag.tagContent"
                  v-for="tag in dynamicTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)">
            {{tag.tagContent}}
          </el-tag>
          <el-input
                  style="width: 200px;margin-bottom: 5px"
                  class="input-new-tag"
                  v-model="inputValue"
                  maxlength="50"
                  placeholder="请输入标签"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
          >
          </el-input>
        </div>
      </el-card>

    </div>

    <!-- 选择话题 -->
    <div class="msg" v-if="dataDetail.manageType != '2'" >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="margin-right: 10px">关联话题</span>
          <el-tooltip placement="bottom-start" effect="light" >
            <div slot="content" v-if="dataDetail.manageType == '1'">该区域可以设置用户作品关联至指定话题，并在对应话题模块同步展示。</div>
            <div slot="content" v-if="dataDetail.manageType == '3'">该区域可以设置用户回答关联至指定话题，并在对应话题模块同步展示。</div>
            <em class="el-icon-question" style="color: #1C69D3; margin-right: 10px"></em>
          </el-tooltip>
        </div>
        <div style="margin:  0px 0px 20px 0px"  >
          <el-button type="primary" @click="themeDataCon()">选择话题</el-button>
        </div>
        <el-tag
          :key="theme.themeId"
          v-for="theme in themesCon"
          closable
          :disable-transitions="false"
          @close="handleClose2Con(theme)">
          {{theme.themeTitle}}
        </el-tag>
      </el-card>
      <!-- 选择话题 -->
      <el-dialog title="选择话题"
                 :visible.sync="isShowThemeCon"
                 width="700px">
        <el-row style="height: 34px; margin-bottom: 20px">
          <el-col :span="3">
            <p style="margin: 0; line-height: 34px">话题名称</p>
          </el-col>
          <el-col :span="11">
            <el-input v-model="themeTitle" :clearable="true"></el-input>
          </el-col>
          <el-col :span="10" style="text-align: right">
            <el-button type="primary" @click="findThemeCon()">查找</el-button>
          </el-col>
        </el-row>
        <div>
          <el-table :data="themeListCon"
                    class="jySelectionAll"
                    ref="multipleTableCon"
                    highlight-current-row
                    border
                    row-key="themeId"
                    v-loading="dataListLoading"
                    height=280
                    @select="selectRedio">
            <el-table-column type="selection"
                             header-align="center"
                             align="center"
                             width="50"
                             >
            </el-table-column>
            <!-- 专题名称 -->
            <el-table-column prop="themeTitle"
                             label="话题名称"
                             width="305"
                             header-align="center"
                             show-overflow-tooltip
                             align="center"></el-table-column>
            <!-- 话题分类 -->
            <el-table-column prop="categoryName"
                             label="话题分类"
                             width="304"
                             header-align="center"
                             show-overflow-tooltip
                             align="center">
            </el-table-column>
          </el-table>
          <el-pagination @size-change="pageSizeChangeHandleCon"
                         @current-change="pageCurrentChangeHandleCon"
                         :current-page="pageCon"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="limitCon"
                         style="text-align: right"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalCon">
          </el-pagination>
          <div style="text-align: right; margin-top: 20px">
            <el-button @click="isShowThemeCon = false">取 消</el-button>
            <el-button type="primary" @click="selectThemeCon()">选 择</el-button>
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 专区 -->
    <div class="msg" v-if="dataDetail.manageType !== '3'" >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="margin-right: 10px">关联专区</span>
          <el-tooltip placement="bottom-start" effect="light" >
            <div v-if="dataDetail.manageType === '1'" slot="content">该区域可以设置用户作品审核发布后，可在指定的关联专区模块里同步显示。</div>
            <div v-if="dataDetail.manageType === '2'" slot="content">该区域可以设置用户提问审核发布后，可在指定的关联专区模块里同步显示。</div>
            <em class="el-icon-question" style="color: #1C69D3; margin-right: 10px"></em>
          </el-tooltip>
        </div>

        <div style="margin: 0px 0px 20px 0px" >
          <el-button type="primary" @click="themeData()">关联专区</el-button>
        </div>
        <el-tag
            :key="theme.id"
            v-for="theme in themes"
            closable
            style="margin-bottom: 5px"
            :disable-transitions="false"
            @close="handleClose2(theme)">
            {{theme.name}}
          </el-tag>
      </el-card>
      <!-- 选择专区 -->
      <el-dialog title="选择专区"
              :visible.sync="isShow"
              width="700px">
        <el-row style="height: 34px; margin-bottom: 20px">
          <el-col :span="3">
            <p style="margin: 0; line-height: 34px">专区名称</p>
          </el-col>
          <el-col :span="11">
            <el-input v-model="themeName" :clearable="true"></el-input>
          </el-col>
          <el-col :span="10" style="text-align: right">
            <el-button type="primary" @click="findTheme()">查找</el-button>
          </el-col>
        </el-row>
        <div>
          <el-table :data="themeList"
                ref="multipleTable"
                highlight-current-row
                border
                v-loading="dataListLoading"
                row-key="id"
                height=280
                @selection-change="dataListSelectionChangeHandle">
            <el-table-column type="selection"
                              header-align="center"
                              align="center"
                              width="50"
                              :reserve-selection="true">
            </el-table-column>
            <!-- 专题名称 -->
            <el-table-column prop="name"
                            label="专区名称"
                            width="305"
                            header-align="center"
                            show-overflow-tooltip
                            align="center"></el-table-column>
            <!-- 创建人 -->
            <el-table-column prop="createUserName"
                            label="创建人"
                            width="304"
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
            </el-table-column>
          </el-table>
          <el-pagination @size-change="pageSizeChangeHandle"
                        @current-change="pageCurrentChangeHandle"
                        :current-page="page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="limit"
                          style="text-align: right"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
          </el-pagination>
          <div style="text-align: right; margin-top: 20px">
              <el-button @click="isShow = false">取 消</el-button>
              <el-button type="primary" @click="selectTheme()">选 择</el-button>
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 作品设置 -->
    <div class="msg" v-if="dataDetail.manageType == '1' || dataDetail.manageType == '3' ">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
        <span style="margin-right: 10px" v-if="dataDetail.manageType == '1' ">悦选作品</span>
        <span style="margin-right: 10px" v-if="dataDetail.manageType == '3' ">悦选回答</span>
          <el-tooltip placement="bottom-start" effect="light" >
            <div slot="content" v-if="dataDetail.manageType == '1' ">可以设置该作品为高质量作品，并在app端标记显示为“悦选”。</div>
            <div slot="content" v-if="dataDetail.manageType == '3' ">可以设置该回答为高质量回答，并在app端标记显示为“悦选”。</div>
            <em class="el-icon-question" style="color: #1C69D3"></em>
          </el-tooltip>
        </div>
        <div>
          <el-row>
            <el-col :span="2" style="width: 120.91px" v-if="dataDetail.manageType == '1' ">
              <span>悦选作品</span>
            </el-col>
            <el-col :span="2" style="width: 120.91px" v-if="dataDetail.manageType == '3' ">
              <span>悦选回答</span>
            </el-col>
            <el-col :span="12" style="margin-bottom: 20px">
              <el-radio-group v-model="isPick">
                <el-radio :label=1>是</el-radio>
                <el-radio :label=0>否</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>

  </div>
</template>

<script>
import groupType from "./groupType";
import label from '../sys/label.vue'
  export default {
  components: { label, groupType },
    name: "creationSharingApprove",
    data() {
      return {
        imageList: [],
        dynamicTags: [],
        dynamicAnswerTags: [],
        dynamicTagsOld: [],
        fileType: '',
        inputValue: '',
        dataDetail: {},
        workStatus: '',
        worksSubmitterName: '',
        approveUserName: '',
        reason: '',
        approveResult: '',
        isShow: false,
        isShowThemeCon: false,
        themeName: '',
        themeTitle: '',
        showTag: false,
        themes: [],
        themesCon: [],
        themeMultipleSelection: [],
        themeMultipleSelectionCon: [],
        themeList: [],
        themeListCon: [],
        curThemes:{},               // 当前的话题
        page: 1,                    // 当前页码
        pageCon: 1,                    // 当前页码
        limit: 10,                  // 每页数
        limitCon: 10,                  // 每页数
        total: 0,
        totalCon: 0,
        saveButton: false,
        dataListLoading : false,
        themeId: '', //话题ID
        isThemeOut : false, //话题是否选中
        isPick:'',//是否悦选
        manageType:'',//类型（1：作品；2：提问；3：回答）


        // 品牌
        brands:[],
        brandsList:[],
        firstbrandsList:[],
        isInitBrand:false,
        isSelectBrand:false,
        brandCodeInfoList:[],
        userDefBrandList:[],    // 用户默认的所属品牌
        brandDoc:{
          "1":"该区域显示本作品提交用户的所属品牌信息，可在下方进行编辑保存",  // 作品
          "2":"该区域显示本提问提交用户的所属品牌信息，可在下方进行编辑保存",  // 提问
          "3":"该区域显示本回答所属提问的品牌信息"       // 回答
        },
        questionGroupText: ''
      }
    },

    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      // this.getInfo()
    },
    activated() {
      this.saveButton = false
      this.getInfo()
    },
    methods: {
      handleClose(tag) {
        console.log('handleClose_标签')
          this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
          this.dataDetail.tagList.forEach(row => {
            if(row.id === tag.id) {
              row.status = 20
            }
          })

      },
      handleClose2(theme) {
        this.themes.splice(this.themes.indexOf(theme), 1);
      },
      handleInputConfirm() {
        let inputValue = {
          tagContent: '',
          status: 30
        }
        inputValue.tagContent = this.inputValue;
        if (inputValue.tagContent) {
          if(inputValue.tagContent.charAt(0) !== '#') {
            inputValue.tagContent = '#' + inputValue.tagContent
          }
          this.dynamicTags.push(inputValue)
        }
        this.inputValue = '';
      },
      // 专区
      themeData() {
        this.isShow = true
        this.$nextTick(() => { this.$refs.multipleTable.clearSelection() })
        this.themeMultipleSelection = []
        // 专区list取得
        this.page=1
        this.limit=10
        this.themeName = ''
        this.getDataList()
        if (this.themes) {
          this.themes.forEach(data => {
            this.themeList.forEach(row => {
              if(data.id == row.id) {
                this.$nextTick(() => {
                  this.$refs.multipleTable.toggleRowSelection(row, true)
                })
              }
            })
          })
        }
      },
      getDataList() {
        this.dataListLoading = true
        // 专区list取得
        this.$request
          .get('/grow/cocreationsharingmanage/getZoneList', {
            page: this.page,
            limit: this.limit,
            name: this.themeName
          })
          .then((res, total, code, data) => {
            this.dataListLoading = false
            this.themeList = data.data.themeList
            this.themeList.forEach((row) => {
              row.createUserName = data.data.userMap[row.createBy].userName
            })
            this.page = data.data.pageNo
            this.limit = data.data.pageSize
            this.total = data.data.totalCount
            if (this.themes && this.isShow) {
              this.themes.forEach(data => {
                this.themeList.forEach(row => {
                  if(data.id == row.id) {
                    this.$nextTick(() => {
                      this.$refs.multipleTable.toggleRowSelection(row, true)
                    })
                  }
                })
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },

      // 勾选数据
      dataListSelectionChangeHandle (val) {
        this.themeMultipleSelection = []
        for (let i = 0; i < val.length; i++) {
          let theme = {}
          theme.id = val[i].id
          theme.name = val[i].name
          theme.createUserName = val[i].createUserName
          this.themeMultipleSelection.push(theme)
        }
      },
      // 专区查找
      findTheme() {
        this.dataListLoading = true
        // 专区查找
        this.$request
          .get('/grow/cocreationsharingmanage/getZoneList', {
            page: 1,
            limit: 10,
            name: this.themeName
          })
          .then((res, total, code, data) => {
            this.dataListLoading = false
            this.themeList = data.data.themeList
            this.themeList.forEach((row) => {
              row.createUserName = data.data.userMap[row.createBy].userName
            })
            this.page = data.data.pageNo
            this.limit = data.data.pageSize
            this.total = data.data.totalCount
          })
          .catch((err) => {
            console.log(err)
          })
      },
      // 专区选择
      selectTheme() {
        this.themes = JSON.parse(JSON.stringify(this.themeMultipleSelection))
        this.isShow = false
      },
      // 分页, 每页条数
      pageSizeChangeHandle (val) {
        this.page = 1
        this.limit = val
        console.log("==============")
        this.getDataList()
      },
      // 分页, 当前页
      pageCurrentChangeHandle (val) {
        console.log("--------------",val)
        this.page = val
        this.getDataList()
      },

      // ----------------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------------
      // --------------------------------------话题搜索__start------------------------------------------
      // ----------------------------------------------------------------------------------------------

      // 话题
      themeDataCon() {
        this.isShowThemeCon = true
        this.pageCon = 1
        this.themeTitle = ""
        this.$nextTick(() => { this.$refs.multipleTableCon.clearSelection() })
        this.themeMultipleSelectionCon = []
        // 专区list取得
        this.getDataListCon()
      },
      // 取消话题选择
      handleClose2Con(theme) {
        console.log('删除话题',theme)
        this.themesCon.splice(this.themesCon.indexOf(theme), 1);
        this.themeId = ''
        this.dataDetail.themeId = ''
        if (this.dataDetail.manageType === '1') {
          this.dynamicTags = JSON.parse(JSON.stringify(this.dynamicTagsOld))
        }else if (this.dataDetail.manageType === '3') {
          var list = []
          this.dynamicAnswerTags.forEach(item=>{
            console.log(item)
            if (item.status!==30) {
              list.push(item)
            }
          })
          this.dynamicAnswerTags = list
        }

        this.isThemeOut = false
        this.curThemes = theme;
        this.deleteBrand(theme);
        this.curThemes = null;
      },

      deleteBrand(theme){
        if (this.dataDetail.manageType === '1') {
          if(this.themesCon.length == 0){
            // 取消了话题关联
            this.isSelectBrand = true;
            //this.brandsList = this.firstbrandsList;
            this.brandsList = this.userDefBrandList
          }else{
            this.isSelectBrand = false;
          }
        }//beandCodes
        if (this.dataDetail.manageType === '3') {
          if(theme.beandCodes != null && theme.brandsList == null){
            theme.brandsList = theme.beandCodes;
          }

          for(var thIndex = 0; thIndex < theme.brandsList.length; thIndex++){
            var index = -1;
            for(var i = 0; i < this.brandCodeInfoList.length; i++){
              if(this.brandCodeInfoList[i].tp == "t" && this.brandCodeInfoList[i].brandCode == theme.brandsList[thIndex]){
                index = i;
                break;
              }
            }

            if(index > -1){
              this.brandCodeInfoList.splice(index,1);
            }
          }
          this.brandsList = [];
          for(var i = 0; i < this.brandCodeInfoList.length; i++){
            if(this.brandsList.indexOf(this.brandCodeInfoList[i].brandsList) < 0){
              this.brandsList.push(this.brandCodeInfoList[i].brandCode);
            }
          }
        }
      },

      getDataListCon() {
        this.dataListLoading = true
        // 专区list取得
        this.$request
                .get('/grow/theme/dialogFindPage', {
                  themeStatus: 20,
                  themeTitle: this.themeTitle,
                  page: this.pageCon,
                  limit: this.limitCon
                })
                .then((res, total, code, data) => {
                  this.dataListLoading = false
                  this.themeListCon = data.data.records
                  this.themeMultipleSelectionCon = JSON.parse(JSON.stringify(this.themesCon))
                  this.pageCon = data.data.current
                  this.limitCon = data.data.size
                  this.totalCon = data.data.total
                  if (this.themesCon && this.isShowThemeCon) {
                    this.themesCon.forEach(data => {
                      this.themeListCon.forEach(row => {
                        if(data.themeId === row.themeId) {
                          this.$nextTick(() => {
                            this.$refs.multipleTableCon.toggleRowSelection(row, true)
                          })
                        }
                      })
                    })
                  }
                })
                .catch((err) => {
                  console.log(err)
                })
      },

      // 单选
      selectRedio: function selectRedio (selection, row) {
        if (this.$refs.multipleTableCon.selection.length > 0) {
          this.$refs.multipleTableCon.clearSelection()
          this.$refs.multipleTableCon.toggleRowSelection(row)

          this.themeMultipleSelectionCon = []
          let theme = {}
          theme.themeId = row.themeId
          theme.themeTitle = row.themeTitle
          theme.createUserName = row.createName
          theme.brandsList = row.brandsList;


          this.themeMultipleSelectionCon.push(theme)
          this.themeId = row.themeId

        }else {
          this.themeId = ""
          this.themeMultipleSelectionCon = []
        }
      },

      // 根据话题搜索相关信息
      getThemeTag(themeId){
        this.$request
          .get(`/grow/theme/getDetail/`+themeId)
          .then((res, total, code, data) => {
            console.log(data.data)
            // 这里对标签赋值 并且把标签设置为不可编辑
            this.dynamicTags = []
            data.data.tags.forEach(row => {
              let inputValue = {
                tagContent: row.tagContent,
                status: 30
              }
              this.dynamicTags.push(inputValue)
            })

          })
          .catch((err) => {
            console.log(err)
          })
      },

      // 根据话题搜索相关信息-回答关联话题是调用
      getAnswerThemeTag(themeId){
        this.$request
                .get(`/grow/theme/getDetail/`+themeId)
                .then((res, total, code, data) => {
                  console.log(data.data)
                  var list = []
                  this.dynamicAnswerTags.forEach(item=>{
                    console.log(item)
                    if (item.status!==30) {
                      list.push(item)
                    }
                  })
                  // 这里对标签赋值 并且把标签设置为不可编辑
                  data.data.tags.forEach(row => {
                    let inputValue = {
                      tagContent: row.tagContent,
                      status: 30
                    }
                    list.push(inputValue)
                  })
                  this.dynamicAnswerTags = list

                })
                .catch((err) => {
                  console.log(err)
                })
      },

      // 话题查找
      findThemeCon() {
        this.dataListLoading = true
        // 专区查找
        this.$request
                .get('/grow/theme/dialogFindPage', {
                  page: 1,
                  limit: 10,
                  themeTitle: this.themeTitle,
                  themeStatus: 20
                })
                .then((res, total, code, data) => {
                  this.themeListCon = data.data.records
                  this.pageCon = data.data.current
                  this.limitCon = data.data.size
                  this.totalCon = data.data.total

                  if (this.themeMultipleSelectionCon && this.isShowThemeCon) {
                    this.themeMultipleSelectionCon.forEach(data => {
                      this.themeListCon.forEach(row => {
                        if(data.themeId === row.themeId) {
                          this.$nextTick(() => {
                            this.$refs.multipleTableCon.toggleRowSelection(row, true)
                          })
                        }
                      })
                    })
                  }
                  this.dataListLoading = false
                })
                .catch((err) => {
                  console.log(err)
                })
      },
      // 话题选择
      selectThemeCon() {
        console.log("this.themeId",this.themeId)
        if (this.themeId != '' && this.dataDetail.manageType === '1') {
          console.log("作品话题选择："+this.themeId)
          this.getThemeTag(this.themeId)
          this.isThemeOut = true
        } else if (this.themeId != '' && this.dataDetail.manageType === '3') {
          console.log("回答话题选择："+this.themeId)
          this.getAnswerThemeTag(this.themeId)
          this.isThemeOut = true
        } else {
          console.log("话题选择else："+this.themeId)
          this.isThemeOut = false
        }
        if (this.$refs.multipleTableCon.selection.length > 0) {
          this.themesCon = JSON.parse(JSON.stringify(this.$refs.multipleTableCon.selection))
        } else {
          this.themesCon = JSON.parse(JSON.stringify(this.themeMultipleSelectionCon))
        }
        if (this.themesCon.length <= 0) {
          if (this.dataDetail.manageType === '1') {
            // 作品还原旧标签
            this.dynamicTags = JSON.parse(JSON.stringify(this.dynamicTagsOld))
            this.isThemeOut = false
            this.dataDetail.themeId = ''
          }else if (this.dataDetail.manageType === '3') {
            // 回答从提问标签组中删除话题标签，status=10是提问标签，status=30是话题标签
            var list = []
            this.dynamicAnswerTags.forEach(item => {
              //console.log(item)
              if (item.status !== 30) {
                list.push(item)
              }
            })
            this.dynamicAnswerTags = list
          }
        }
        console.log(this.themesCon)
        console.log(this.themeMultipleSelectionCon)
        this.isShowThemeCon = false
        if(this.curThemes != null) {
          this.deleteBrand(this.curThemes);
        }
        if (this.dataDetail.manageType === '1' && this.themesCon[0]) {
          this.brandsList = this.themesCon[0].brandsList
          this.isSelectBrand = false;
        }
        if (this.dataDetail.manageType === '3' && this.themesCon[0]) {

          for(var i = 0; i < this.themesCon[0].brandsList.length; i++){
            if(this.brandsList.indexOf(this.themesCon[0].brandsList[i]) < 0){
              this.brandsList.push(this.themesCon[0].brandsList[i]);
            }
          }

        }
        if(this.themesCon[0]){
          this.curThemes = this.themesCon[0];
        }
      },
      // 分页, 每页条数
      pageSizeChangeHandleCon (val) {
        this.pageCon = 1
        this.limitCon = val
        this.getDataListCon()
      },
      // 分页, 当前页
      pageCurrentChangeHandleCon (val) {
        this.pageCon = val
        this.getDataListCon()
      },

      // ----------------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------------
      // --------------------------------------话题搜索__end------------------------------------------
      // ----------------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------------
      // 查询
      getInfo() {
        this.dynamicTags = []
        this.dynamicAnswerTags = []
        this.dynamicTagsOld = []
        this.$request
          .get('/grow/cocreationsharingmanage/getDetail', {
            id: this.$route.query.id,
            platformType:'pc'
          })
          .then((res, total, code, data) => {

            console.log(data);
            this.dataDetail = data.data

            this.dynamicAnswerTags = JSON.parse(JSON.stringify(this.dataDetail.answerTagList))
            if (data.data.manageType ==='3') {
              var taglist = []
              this.dataDetail.tagList.forEach(item=>{
                if (item.status === 10) {
                  taglist.push(item)
                }else if (item.status === 30) {
                  this.dynamicAnswerTags.push(item)
                }
              })
              this.dynamicTags = JSON.parse(JSON.stringify(taglist))
            }else {
              this.dynamicTags = JSON.parse(JSON.stringify(this.dataDetail.tagList))
              if (this.dataDetail.themeId === null || this.dataDetail.themeId === ''){
                // 没有关联话题的作品把原有的标签存上，取消关联后在用
                this.dynamicTagsOld = JSON.parse(JSON.stringify(this.dataDetail.tagList))
              }
            }

            console.log("daan ==:"+this.dynamicAnswerTags)
            this.imageList = []
            this.fileType = ''
            if(data.data.fileList && data.data.fileList.length > 0) {
              this.fileType = data.data.fileList[0].fileType
              if(this.fileType == '10') {
                for(const file of this.dataDetail.fileList) {
                  this.imageList.push(file.fileUrl)
                }
              }
            }
            this.brandsList = data.data.brandsList == null ? [] : data.data.brandsList;
            this.brandCodeInfoList = data.data.brandCodeInfoList == null ? [] : data.data.brandCodeInfoList;

            this.userDefBrandList = data.data.userDefBrandList;
            if(this.dataDetail.manageType == "1" || this.dataDetail.manageType == "3"){
              for(var i = 0; i < this.brandCodeInfoList.length; i++){
                if(this.brandsList.indexOf(this.brandCodeInfoList[i].brandCode) < 0){
                  this.brandsList.push(this.brandCodeInfoList[i].brandCode);
                }
              }

            }

            if(this.dataDetail.manageType == "1"){
              if(this.dataDetail.themeId == null || this.dataDetail.themeId == ''){
                // 没有绑定话题 可以随便修改
                this.isSelectBrand = true;
              }else{
                this.isSelectBrand = false;
              }
            }
            if(this.dataDetail.manageType == "2"){
              this.isSelectBrand = true;
            }
            if(this.dataDetail.manageType == "3"){
              this.isSelectBrand = false;
            }

            // 作品提交人和审批人
            this.worksSubmitterName = this.dataDetail.worksSubmitterName
            this.approveUserName = this.dataDetail.approveUserName
            if (this.dataDetail.worksSubmitterName && this.dataDetail.worksSubmitterCode) {
              this.worksSubmitterName = this.dataDetail.worksSubmitterName + '（' + this.dataDetail.worksSubmitterCode + '）'
            }
            if (this.dataDetail.approveUserName && this.dataDetail.approveUserCode) {
              this.approveUserName = this.dataDetail.approveUserName + '（' + this.dataDetail.approveUserCode + '）'
            }

            this.isPick = this.dataDetail.isPick
            this.approveResult = this.dataDetail.workStatus
            this.reason = this.dataDetail.approveReason
            // 作品状态
            if (this.dataDetail.workStatus == 10) {
              this.workStatus = '待审核'
            } else if (this.dataDetail.workStatus == 20) {
              this.workStatus = '已发布'
            } else if (this.dataDetail.workStatus == 30) {
              this.workStatus = '未通过'
            } else if (this.dataDetail.workStatus == 40) {
              this.workStatus = '已删除'
            } else if (this.dataDetail.workStatus == 60) {
              this.workStatus = '已屏蔽'
            } else {
              this.workStatus = ' '
            }
            // 关联专区
            this.themes = []
            if(this.dataDetail.associatedZoneMap) {
              for (var key in this.dataDetail.associatedZones) {
                let obj = {}
                obj.id = this.dataDetail.associatedZones[key]
                obj.name = this.dataDetail.associatedZoneMap[obj.id]
                this.themes.push(obj);
              }
            }
            this.themesCon = []
            //展示话题
            if (this.dataDetail.themeId != null && this.dataDetail.themeId != '') {
              console.log("展示话题:"+this.dataDetail.themeId)
              let the = {"themeId":this.dataDetail.themeId,"themeTitle":this.dataDetail.theme[0],"beandCodes":this.dataDetail.themeBeandCodes}
              this.curThemes = the;
              console.log(the)
              this.themesCon.push(the)
              this.themeListCon.push(the)
              this.isThemeOut = true
              this.themeId = this.dataDetail.themeId
            } else {
              console.log("展示话题else:"+this.dataDetail.themeId)
              this.isThemeOut = false
              this.curThemes = null;
              this.firstbrandsList = this.brandsList;
            }

            if(this.isInitBrand == false){
              var brandArr = this.enums['brandCode'];
              try{
                for(var i = 0; i < brandArr.length; i++){
                    if(brandArr[i].code){
                      this.brands.push(brandArr[i]);
                    }
                }
                this.isInitBrand = true;
              }
              catch(e) {
                console.log(e.message);
              }
            }



          })
          .catch((err) => {
            console.log(err)
          })
      },
      // 返回
      goBack() {
        this.$router.push({ name: 'grow-creationSharingManage' })
        this.$store.state.contentTabs.splice(this.$store.state.contentTabs.findIndex(item => item.path === this.$route.path), 1)
      },
      // 保存
      save() {
        this.saveButton = true

        //alert(this.brandsList.length);
        // 校验品牌必填
        if(this.brandsList.length == 0){

            this.$message({
              message: '品牌必填，请确认！',
              type: 'error',
              duration: 2000
            })
            this.saveButton = false
            return false
        }

        console.log("类型："+this.dataDetail.manageType)
        console.log("标签: "+this.dynamicTags)
        if(this.dynamicTags == null || this.dynamicTags ==''){
          if(this.dataDetail.manageType == '2' || this.dataDetail.manageType == '1' ){
              this.$message({
                message: '标签必填，请确认！',
                type: 'error',
                duration: 2000
              })
              this.saveButton = false
              return false
            }
        }
        if(this.dynamicAnswerTags == null || this.dynamicAnswerTags ==''){
          if(this.dataDetail.manageType == '3' ){
            console.log("类型："+this.dataDetail.manageType)
            console.log("标签: "+this.dynamicTags)

            this.$message({
              message: '标签必填，请确认！',
              type: 'error',
              duration: 2000
            })
            this.saveButton = false
            return false
          }
        }
        if(this.dataDetail.manageType != '2'){
          if(this.isPick !=1 && this.isPick != 0){
            this.$message({
              message: '请选择是否为悦选!',
              type: 'error',
              duration: 2000
            })
            this.saveButton = false
            return false
          }
        }
        if (this.approveResult != 20 && this.approveResult != 30) {
          this.$message({
            message: '请选择审核结果!',
            type: 'error',
            duration: 2000
          })
          this.saveButton = false
          return false
        }
        if (this.approveResult == 30 && (this.reason == '' || this.reason == null)) {
          this.$message({
            message: '请输入未通过的理由!',
            type: 'error',
            duration: 2000
          })
          this.saveButton = false
          return false
        }

        let associatedZone = []
        if(this.themes){
          this.themes.forEach(row => {
            associatedZone.push(row.id.toString())
          })
        }
        if(this.dynamicTags){
          this.dynamicTags.forEach(row => {
            if(row.status == 30) {
              this.dataDetail.tagList.push(row)
            }
          })
        }
        //console.log(this.dynamicTags)
        var postObj = {
            id: this.dataDetail.id,
            title: this.dataDetail.title,
            tagList: this.dynamicTags,
            isPick:this.isPick,
            workStatus: this.approveResult,
            approveReason: this.reason,
            themeId: this.themeId,
            associatedZones: associatedZone,
            brandsList:this.brandsList,
            manageType:this.dataDetail.manageType
          };
          console.log(postObj)
        this.$request
          .post('/grow/cocreationsharingmanage/approveWorksUpdateTheme', postObj)
          .then((res, total, code, data) => {
            this.$message({
              message: "保存成功",
              type: 'success',
              duration: 500,
              onClose: () => {
                this.goBack()
              }
            })
          })
          .catch(() => {
            this.saveButton = false
          })
      },

      // 分组转换
      getGroup (cellValue) {
        var list = cellValue
        list.forEach(item=>{
          if (item.dictValue === this.dataDetail.questionGroupType) {
            this.questionGroupText = item.dictName
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>

  .search {
      text-align: right;
      margin-bottom: 0px;
  }

   .card1 .el-card__body {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .pkg-content {
    background-color: #f9f9f9;
    position: relative;
  }

  .msg {
    margin: 0 50px;
    padding: 10px 0;
    position: relative;
  }

  .msg span {
    font-weight: 600;
    margin-right: 20px;
  }

  pre {
    white-space: normal;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    font-family: BMWGlobalProReg, "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 14px;
  }


</style>
<style lang="scss">
/* 隐藏网格的全选按钮 */
.jySelectionAll
> .el-table__header-wrapper
> .el-table__header
> thead
> tr
> th
> .cell
> label {
  display: none !important;
}
.el-tooltip__popper {
  max-width: 430px !important;
}
</style>
